import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";
import { useTheme } from "@mui/material";
import { Text, View } from "@react-pdf/renderer";
import { HorizontalLine } from "../../export-pdf/components/horizontal-line";
import { PDFTable } from "../../export-pdf/components/tables/table";
import { PDFTableBody } from "../../export-pdf/components/tables/table-body";
import { PDFTableCell } from "../../export-pdf/components/tables/table-cell";
import { PDFTableRow } from "../../export-pdf/components/tables/table-row";
import { PDFStyleConfigs } from "../../export-pdf/configs";

type PDFFeePortfolioDetailsProps = {
  isPlatformAnalysis?: boolean;
  title?: string;
  tableRows: { label: string | JSX.Element; value: string }[];
};

export const PDFFeePortfolioDetails = ({
  isPlatformAnalysis,
  tableRows,
  title,
}: PDFFeePortfolioDetailsProps) => {
  const { palette: originalPalette } = useTheme();
  const { typographyStyle } = useAnalysisPDFStyles();

  return (
    <View>
      <View style={{ height: PDFStyleConfigs.SubTitleHeight }}>
        <Text
          style={{
            ...typographyStyle.title,
            color: originalPalette.common.black,
          }}
        >
          {isPlatformAnalysis ? "Fee analysis" : "Fee review"}
        </Text>

        <HorizontalLine color={originalPalette.common.black} />

        <Text
          style={{
            ...typographyStyle.subtitle,
            color: originalPalette.common.black,
          }}
        >
          {title}
        </Text>
      </View>

      <PDFTable>
        <PDFTableBody>
          {tableRows?.map((row, index) => (
            <PDFTableRow key={index}>
              <PDFTableCell
                width={PDFStyleConfigs.PortfolioDetailsFirstColumnWidth}
                alignItems={"flex-start"}
                justifyContent={"center"}
              >
                <Text
                  style={{
                    ...typographyStyle.body2,
                    fontWeight: "bold",
                    lineHeight: 1.2,
                    paddingTop: 2,
                  }}
                >
                  {row.label}
                </Text>
              </PDFTableCell>

              <PDFTableCell
                width={PDFStyleConfigs.PortfolioDetailsValueColWidth}
                alignItems={"flex-start"}
                justifyContent={"center"}
              >
                <Text
                  style={{
                    ...typographyStyle.body2,
                    lineHeight: 1.2,
                    paddingTop: 2,
                  }}
                >
                  {row.value}
                </Text>
              </PDFTableCell>
            </PDFTableRow>
          ))}
        </PDFTableBody>
      </PDFTable>
    </View>
  );
};
